import { SVGProps, Ref, forwardRef } from 'react';

export const HhGrayscaleSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11" fill="#919191" />
        <path
            d="M17.55 10.668c-.332-.353-.805-.546-1.383-.546-.717 0-1.269.3-1.586.861V8.197h-1.664v7.637h1.664v-2.685c0-.626.125-1.027.312-1.262.182-.236.437-.326.713-.326.244 0 .437.08.572.224.135.15.213.38.213.7v3.343h1.664v-3.68c0-.625-.177-1.133-.504-1.48"
            fill="#E2E2E2"
        />
        <path
            d="M11.143 10.668c-.333-.353-.806-.546-1.384-.546-.717 0-1.269.3-1.586.861V8.197H6.51v7.637h1.664v-2.685c0-.626.125-1.027.312-1.262.182-.236.437-.326.713-.326.244 0 .437.08.572.224.135.15.213.38.213.7v3.343h1.664v-3.68c0-.625-.177-1.133-.504-1.48"
            fill="#E2E2E2"
        />
    </svg>
));
HhGrayscaleSize24Glyph.displayName = 'HhGrayscaleSize24Glyph';
